//
// Action types
//

export const INITIALIZE_LIST = "INITIALIZE_LIST";

//
// Action creators
//

export function initializeList(resourcesListKey) {
  return { type: INITIALIZE_LIST, resourcesListKey };
}

//
// Reducer and handlers
//

export function reduceListInitialization(state) {
  return state || {};
}
